var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showing)?_c('div',[_c('div',{staticClass:"loading-overlay d-flex justify-center align-center",attrs:{"click.stop.prevent":""}},[_c('v-progress-circular',{staticStyle:{"z-index":"1000"},attrs:{"size":"46","color":"primary","indeterminate":""}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }